import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Insert"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 6.75H8.25V1.5H1.5V6.75ZM3 3H6.75V5.25H3V3ZM1.5 14.25H8.25V9H1.5V14.25ZM3 10.5H6.75V12.75H3V10.5ZM1.5 21.75H8.25V16.5H1.5V21.75ZM3 18H6.75V20.25H3V18ZM20.25 6.75H13.5L16.0575 4.0575L15 3L10.5 7.5L15 12L16.0575 10.9425L13.5 8.25H20.25C20.6642 8.25 21 8.58579 21 9V18C21 18.4142 20.6642 18.75 20.25 18.75H11.25V20.25H20.25C21.4926 20.25 22.5 19.2426 22.5 18V9C22.5 7.75736 21.4926 6.75 20.25 6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Insert.vue"]]);
